<!--
 * @Description:
 * @Author: LXG
 * @Date: 2022-01-27
 * @Editors: LXG
 * @LastEditTime: 2022-01-27
-->

<!-- 写样式的地方 -->
<template>
  <div class="background">
    <div class="register-container">
      <div class="banner-limit register-public-announcement">
        <div class="register-self">
          <div style="text-align: center;font-size: 20px;color: red;font-weight: bold;
          margin-top: 1rem;margin-bottom: 1rem;">欢 迎 企 业 注 册
          </div>
          <div class="form-container flex-row-between">
            <div class="form-left">
              <el-form
                ref="registerUserMessage"
                :model="registerUserMessage"
                :rules="rules"
                label-width="120px"
                label-position="left"
                :status-icon="true"
                size="small"
                :hide-required-asterisk="false"
              >
                <div class="flex-row form-row">
                  <el-form-item
                    label="登录账户"
                    prop="userAccount"
                  >
                    <el-input
                      v-model="registerUserMessage.userAccount"
                      autocomplete="off"
                      placeholder="最少6位账户名，包含小写字母，数字组合"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="flex-row form-row">
                  <el-form-item
                    label="登录密码"
                    prop="password"
                  >
                    <el-input
                      type="password"
                      v-model="registerUserMessage.password"
                      autocomplete="off"
                      placeholder="最少6位密码，包含小写字母，数字组合"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="flex-row form-row">
                  <el-form-item
                    label="确认密码"
                    prop="password2"
                  >
                    <el-input
                      type="password"
                      v-model="registerUserMessage.password2"
                      autocomplete="off"
                      placeholder="请再次输入密码"
                    ></el-input>
                  </el-form-item>
                  <!--<span class="el-input-comments">请再次输入密码</span>-->
                </div>
              </el-form>
              <el-form
                ref="form"
                :model="form"
                :rules="rules"
                label-width="120px"
                label-position="left"
                :status-icon="true"
                size="small"
                :hide-required-asterisk="false"
                style="padding-top:0;"
              >
                <div class="flex-row form-row">
                  <el-form-item
                    label="法人姓名"
                    prop="userName"
                  >
                    <el-input
                      v-model="form.userName"
                      autocomplete="off"
                      placeholder="请输入法人姓名"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="flex-row form-row">
                  <el-form-item
                    label="法人手机号"
                    prop="userMobile"
                  >
                    <el-input
                      v-model="form.userMobile"
                      autocomplete="off"
                      placeholder="请输入法人手机号"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="flex-row form-row">
                  <el-form-item
                    label="法人证件号"
                    prop="certNo"
                  >
                    <el-input
                      v-model="form.certNo"
                      autocomplete="off"
                      placeholder="请输入法人证件号"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="flex-row form-row">
                  <el-form-item
                    label="企业名称"
                    prop="corpName"
                  >
                    <el-input
                      v-model="form.corpName"
                      autocomplete="off"
                      placeholder="请输入企业名称"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="flex-row form-row">
                  <el-form-item
                    label="社会信用代码"
                    prop="certificateSno"
                  >
                    <el-input
                      v-model="form.certificateSno"
                      autocomplete="off"
                      placeholder="请输入统一社会信用代码"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-form>
              <div class="el-btn-ctr">
                <el-checkbox
                  v-model="checked"
                  style="font-size:14px;"
                >我已阅读并同意
                </el-checkbox>
                <a
                  style="color: #409EFF;"
                  @click="zcxy"
                >《用户注册协议》</a>
              </div>
              <div class="el-btn-ctr">
                <el-button
                  @click.native.prevent="submitForm2('form')"
                  type="primary"
                >注 册
                </el-button>
              </div>
              <div class="to-login">
                <a @click="gotoLogin">已有账号，直接登录</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "register2",
    data() {
      /* 自定义验证规则 */
      let validateUser = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入账号"));
        } else {
          const reg = /^.*(?=.{6,})(?=.*\d)(?=.*[a-z]).*$/;
          console.log(reg.test(value));
          if (reg.test(value)) {
            if (this.registerUserMessage.userAccount !== "") {
              this.$refs.form.validateField("userAccount");
            }
            callback();
          } else {
            return callback(new Error("最少6位，包含小写字母，数字"));
          }
        }
      };

      let validatePass = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入密码"));
        } else {
          console.log('aaaaaaaaaaaaaaaaaaaaaa')
          const reg = /^.*(?=.{6,})(?=.*\d)(?=.*[a-z]).*$/;
          // const reg = /^.*(?=.{6,})(?=.*\d)(?=.*[a-z]).*$/;
          console.log(reg.test(value));
          if (reg.test(value)) {
            if (this.registerUserMessage.password !== "") {
              this.$refs.form.validateField("password");
            }
            callback();
          } else {
            return callback(
              // new Error("最少6位，包含大写字母，小写字母，数字，特殊字符")
              new Error("最少6位，包含小写字母，数字")
            );
          }
        }
      };
      let validatePass2 = (rule, value, callback) => {
        console.log(rule)
        console.log(value)
        console.log('---------------', callback)
        if (value === "") {
          callback(new Error("请再次输入密码"));
        } else if (value !== this.registerUserMessage.password) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      };
      let checkPhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("手机号不能为空"));
        } else {
          const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
          console.log(reg.test(value));
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error("请输入正确的手机号"));
          }
        }
      };
      let checkShxydm = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("社会信用代码不能为空"));
        } else {
          const reg = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/;
          console.log(reg.test(value));
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error("请输入正确的社会信用代码"));
          }
        }
      };
      let checkIdcard = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("证件号码不能为空"));
        } else {
          const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
          console.log(reg.test(value));
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error("请输入正确的证件号码"));
          }
        }
      };
      return {
        // /* 注册类型切换 */
        // registerType: 'first',
        iskjs: false, //是否为会计师  0表示为会计师
        // 默认选择
        activeName: "first",
        checked: false,
        /* 地址选择 */
        baseUrl: {
          first: "/dev-api/regist_enterprise", // 企业
          second: "/dev-api/regist_personal", // 个人
        },
        /* 注册列表 */
        registerUserMessage: {
          userAccount: '',
          password: '',
          password2: '',
        },
        form: {
          certificateSno: '',  // 统一社会信用代码
          corpName: '',        // 法人名称
          corpType: 'C01',     // 法人类型 默认企业法人
          userName: '',        // 用户姓名
          certType: '111',     // 证件类型 默认身份证
          userMobile: '',      // 手机号
          accountType: '20',   // 默认法人账号
          certNo: '',          // 法人身份证号
          userRealLvl: 'RC03', // 默认三级实名认证
          accountId: '1000',   // 表示本地注册
          corpId: '1000',      // 表示本地注册
        },
        cardTypeList: [  // 证件类型
          {vlaue: '111', label: '身份证'},
          {vlaue: '444', label: '普通护照'},
          {vlaue: '511', label: '台湾居民来往大陆通行证'},
          {vlaue: '516', label: '港澳居民来往大陆通行证'},
        ],
        qyTypeList: [  // 企业类型
          {vlaue: 'C01', label: '企业法人'},
          {vlaue: 'C02', label: '社团法人'},
          {vlaue: 'C03', label: '机关单位法人'},
          {vlaue: 'C04', label: '个体工商户'},
        ],
        value: '',
        /* 注册说明 */
        dscnList: [
          {text: "1、较多业务系统将使用填写的注册信息，请如实填写"},
          {text: "2、请牢记注册的登录账号和密码，切勿向他人泄漏"},
        ],
        /* 验证规则 */
        rules: {
          userAccount: [
            {required: true, validator: validateUser, trigger: "blur"},
            // { min: 6, message: "长度大于 6 个字符", trigger: "blur" },
          ],
          password: [{required: true, validator: validatePass, trigger: "blur"}],
          password2: [
            {required: true, validator: validatePass2, trigger: "blur"},
          ],
          userMobile: [{required: true, validator: checkPhone, trigger: "blur"}],
          certificateSno: [{required: true, validator: checkShxydm, trigger: "blur"}],
          certNo: [{required: true, validator: checkIdcard, trigger: "blur"}],
          corpName: [{required: true, message: "请完整输入", trigger: "blur"}],
          userName: [{required: true, message: "请完整输入", trigger: "blur"}],
        },
      };
    },
    methods: {
      zcxy() { // 注册协议
        const {href} = this.$router.resolve({
          path: "/zcxy",
        });
        window.open(href, "_blank");
      },
      // 新的注册
      submitForm2(formName) {
        if (!this.checked) {
          alert('请勾选阅读并同意《用户注册协议》后再进行注册！');
          return false;
        }
        let validStatus = false;
        this.$refs['registerUserMessage'].validate((valid) => {
          if (valid) {
            validStatus = true;
          }
        })
        this.$refs[formName].validate((valid) => {
          if (valid && validStatus) {
            let params = {};
            params.corporator = this.form;
            params.registerUserMessage = this.registerUserMessage;
            const el = this.activeName; // 当前状态
            console.log('注册参数：', params);
            // this.$message.success('注册成功')
            // this.$router.replace({
            //   path: "/suqiuMobile",
            //   // query: {
            //   //     user: this.registerUserMessage.userAccount,
            //   // },
            // });
            // return;
            this.$httpApi
              .post('/dev-api/lhsso/registerUser',
                params
              )
              .then((res) => {
                console.log("注册后", res);
                if (res.code == 200) {
                  this.$message({
                    message: "恭喜你，注册成功",
                    type: "success",
                  });
                  this.$router.replace({
                    path: "/loginMobile",
                    query: {
                      user: this.registerUserMessage.userAccount,
                    },
                  });
                } else if (res.code == 500) {
                  this.$message.error(res.msg || "填写信息错误！");
                }
              })
              .catch((err) => {
                this.$message.error("网络异常，请稍后重试!");
              });
          } else {
            console.log("error submit!!");
            this.$message.closeAll();
            this.$message.error("请填写正确的用户信息!");
            return false;
          }
        });
      },

      /* 注册 */
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = this.form;
            params.kjs = 0
            if (this.iskjs) {
              params.kjs = 1;
            }
            const el = this.activeName; // 当前状态
            this.$httpApi
              .post(
                this.baseUrl[el] +
                "?appid=afc903d9d5e449488a3cf9a00c3d1294&appkey=8cb4f61b-e89a-405b-acc8-4d992826c247",
                params
              )
              .then((res) => {
                console.log("注册后", res);
                if (res.code == 200) {
                  this.$message({
                    message: "恭喜你，注册成功",
                    type: "success",
                  });
                  /*this.$router.replace({
                    path: "/login",
                    query: {
                      user: this.form.userAccount,
                    },
                  });*/
                } else if (res.code == 500) {
                  this.$message.error(res.msg || "填写信息错误！");
                }
              })
              .catch((err) => {
                this.$message.error("网络异常，请稍后重试!");
              });
          } else {
            console.log("error submit!!");
            this.$message.closeAll();
            this.$message.error("请填写正确的用户信息!");
            return false;
          }
        });
      },
      gotoLogin() {
        this.$router.replace({
          path: "/tylogin",
        });
      },
      /**
       * 切换
       */
      handleClick(tab, event) {

      },
    }
  }
</script>

<style lang="scss" scoped>
  .background {
    background-color: white;
    position: relative;
    width: 100vw;
    height: 90vh;
    margin: 0 auto;
    height: 100vh;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
  }

  .register-container {
    width: 90vw;
    position: absolute;
    z-index: 102;
    background-color: white;
    border-radius: 20px;
  }


  /*  注册的 tabs */
  .register-public-announcement {
    width: 90vw;

    .el-tabs {
      .el-tabs__header {
        .el-tabs__nav {
          height: 70px;
        }

        .el-tabs__item {
          height: 26px;
          font-weight: 700;
          // color:#2d81ff;
          font-size: 20px;
          line-height: 70px;
        }

        .el-tabs__active-bar {
          width: 81px;
          height: 5px;
          background-color: #2d81ff;
        }
      }
    }
  }

  /* 注册排版 */
  .register-self {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    /* 表单布局 */
    .form-container {
      width: 100%;
      height: 100%;

      .form-left {
        width: 100%;
        height: 100%;

        span {
          font-size: 14px;
          font-weight: 500;
        }

        /* element UI 表单样式 */
        .el-form {
          //width: 100vw;
          margin: 0 auto;

          .form-row {
            margin-bottom: 10px;
          }

          .el-form-item {
            width: 90vw;
            background: #fff;
            /* label */
            .el-form-item__label {
              height: 38px;
              line-height: 38px;
            }

            /* input框 */
            .el-form-item__content {
              .el-input {
                height: 28px;
                line-height: 38px;

                .el-input__inner {
                  height: 100%;
                  border: none;
                  border-radius: 0;
                }
              }
            }
          }

          /* 每行输入框后边的注释 */
          .el-input-comments {
            height: 40px;
            font-weight: 400;
            color: #828282;
            font-size: 14px;
            text-align: left;
            margin-left: 30px;
            margin-bottom: 20px;
          }
        }

        .el-btn-ctr,
        .to-login {
          width: 90vw;
          padding: 0 40px;
          margin: 20px auto;
          text-align: center;
        }

        .el-button {
          width: 100%;
        }

        .to-login {
          width: 90vw;
          text-align: center;
        }
      }

      .form-right {
        width: 160px;
        height: 100%;
        background: yellow;
      }
    }
  }
</style>
